import type { ApiResponse, ArchetypeCode } from '@/types';

function getApiBaseUrl(): string {
  const envUrl = import.meta.env.VITE_API_URL;
  if (!envUrl) return '/api';
  if (envUrl.endsWith('/api')) return envUrl;
  return envUrl.replace(/\/$/, '') + '/api';
}

const API_BASE_URL = getApiBaseUrl();

async function request<T>(
  endpoint: string,
  options: RequestInit = {}
): Promise<T> {
  const token = localStorage.getItem('auth_token');

  const headers: HeadersInit = {
    'Content-Type': 'application/json',
    ...options.headers,
  };

  if (token) {
    (headers as Record<string, string>)['Authorization'] = `Bearer ${token}`;
  }

  if (window.Telegram?.WebApp?.initData) {
    (headers as Record<string, string>)['X-Telegram-Init-Data'] = window.Telegram.WebApp.initData;
  }

  const response = await fetch(`${API_BASE_URL}${endpoint}`, {
    ...options,
    headers,
  });

  const data: ApiResponse<T> = await response.json();

  if (!response.ok || !data.success) {
    throw new Error(data.error || 'Unknown error');
  }

  return data.data as T;
}

// ============================================
// CHARACTER PROFILE API
// ============================================

export interface CharacterProfile {
  user: {
    id: string;
    firstName: string | null;
    username: string | null;
    photoUrl: string | null;
    avatarUrl: string | null;
  };
  archetypes: {
    primary: ArchetypeCode | null;
    secondary: ArchetypeCode | null;
    shadow: ArchetypeCode | null;
  };
  archetypeDisplayName: string | null;
  secondaryArchetypeDisplayName: string | null;
  characteristics: {
    body_energy: number;
    attention: number;
    emotional_regulation: number;
    communication: number;
    trust_bonds: number;
    agency: number;
    creativity: number;
    meaning: number;
  };
  stage: {
    current: number;
    activeDays: number;
    startedAt: string | null;
    paceMode: string;
  };
  batteryACompleted: boolean;
  batteryBCompleted: boolean;
  batteryCCompleted: boolean;
}

export async function getCharacterProfile(): Promise<CharacterProfile> {
  return request<CharacterProfile>('/character/profile');
}

export async function resetCharacter(): Promise<{ message: string }> {
  return request<{ message: string }>('/character/reset', {
    method: 'POST',
  });
}
